@import "../../../../shared/scss";

@mixin set-skeleton {
  &.skeleton {
    pointer-events: none;
    user-select: none;

    & .skeleton-headline {
      inline-size: 100%;
      block-size: p-px-to-rem(40px);
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
      font-size: p-px-to-rem(28px);
      line-height: p-px-to-rem(40px);
      margin-block-end: p-px-to-rem(8px);

      @include pds-media-query-min("s") {
        margin-block-end: 0;
        font-size: p-px-to-rem(30px);
        line-height: p-px-to-rem(40px);
      }

      @include pds-media-query-min("m") {
        font-size: p-px-to-rem(28px);
        line-height: p-px-to-rem(40px);
      }
    }

    & .skeleton-login-container {
      inline-size: 100%;
      display: flex;
      justify-content: space-between;
      border-radius: 4px;
      gap: 1rem;
      margin-block-end: 1.4375rem;

      @include pds-media-query-min-max("s", "l") {
        flex-direction: column;
      }

      .skeleton-login,
      .skeleton-more {
        block-size: p-px-to-rem(54px);
        inline-size: 100%;
        border-radius: 4px;
        background: $pds-theme-light-contrast-low;
      }
    }

    & .skeleton-signup {
      color: transparent;
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }

    & .skeleton-menu {
      inline-size: 100%;
      block-size: p-px-to-rem(48px);
      border-radius: 4px;
    }

    & .skeleton-menu-item {
      inline-size: 100%;
      block-size: p-px-to-rem(26px);
      background: $pds-theme-light-contrast-low;
      margin-block-start: $pds-spacing-fluid-medium;
      border-radius: 4px;
    }
  }
}

:host {
  display: block;
  margin-block-start: 0;

  @include set-skeleton;

  .myporsche-links {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .myporsche-links-container {
      &.logged-in > .myporsche-link-item:first-child > phn-nd-menu-item {
        padding-block-start: 0;
      }

      .myporsche-link-item > phn-nd-menu-item {
        padding-block-start: $pds-spacing-fluid-medium;
      }
    }

    .menu-item-count {
      margin-inline-start: p-px-to-rem(16px);
    }
  }

  .headline-container {
    border-block-end: 2px solid $pds-theme-dark-background-base;

    @include pds-media-query-min("s") {
      padding-block-end: p-px-to-rem(16px);
    }

    @include pds-media-query-min("xxl") {
      padding-block-end: p-px-to-rem(24px);
    }

    .myporsche-headline {
      font-size: p-px-to-rem(28px);
      line-height: p-px-to-rem(40px);
      padding-block-end: p-px-to-rem(8px);

      @include pds-media-query-min("s") {
        padding-block-end: 0;
        font-size: p-px-to-rem(30px);
        line-height: p-px-to-rem(40px);
      }

      @include pds-media-query-min("m") {
        font-size: p-px-to-rem(28px);
        line-height: p-px-to-rem(40px);
      }
    }

    .headline-divider {
      padding-block: 0;
      padding-inline: p-px-to-rem(16px) p-px-to-rem(18px);
      block-size: p-px-to-rem(32px);
    }

    .user-container {
      padding-block-end: p-px-to-rem(17px);
      display: inline-flex;
      align-items: center;

      phn-p-icon {
        padding-inline-end: p-px-to-rem(7px);
        inline-size: p-px-to-rem(20px);
        block-size: p-px-to-rem(20px);
      }

      phn-p-text {
        font-size: p-px-to-rem(16px);

        @include pds-media-query-min("base") {
          padding-block: 0;
          padding-inline: 0;
        }
      }
    }
  }

  phn-p-divider {
    display: block;
    block-size: 100%;
    align-self: center;
    padding-block: 0;
    padding-inline: p-px-to-rem(119px);

    @include pds-media-query-min("xl") {
      padding-block: 0;
      padding-inline: p-px-to-rem(150px);
    }
  }
}
